import { TeamAPI } from "../../../../src/apis/TeamAPI"
import { GetStaticPropsContext } from "next"
import { Col, Row } from "react-bootstrap"
import React from "react"
import { TeamDetails } from "@components/Team/TeamDetails/TeamDetails"
import { getNavigationPropsForTeam } from "@components/Navigation/getNavigationProps"
import { SEO } from "../../../../src/types/next.js"
import moment from "moment"
import { ParsedUrlQuery } from "querystring"
import InferNextPropsType from "infer-next-props-type"
import * as NextConstants from "../../../../src/constants/next"
import { TeamMenu } from "@components/Team/TeamMenu/TeamMenu"
import { MatchTeamComparisonStats } from "@components/Match/MatchTeamComparisonStats/MatchTeamComparisonStats"
import { MatchAPI } from "../../../../src/apis/MatchAPI"
import { getTeamCanonicalData } from "../../../../src/utils/team"
import { BookmakerBonusAPI } from "../../../../src/apis/BookmakerBonusAPI"
import { simplifyBookmakerBonus } from "../../../../src/utils/bookmakerBonus"
import { TurnMatches } from "@components/Turn/TurnMatches"
import { NewTitleBanner } from "@components/Banners/NewTitleBanner"
import homeTeamStats from "@assets/images/title-banner/home-team-stats.png"

export default function TeamBilancioPage({
  team,
  team2,
  comparisonMatches,
}: InferNextPropsType<typeof getStaticProps>) {
  return (
    <div>
      <Row className={"marginZero"}>
        <TeamDetails team={team} />
      </Row>
      <TeamMenu
        selected="precedenti"
        teamCalciocomSlug={team.calciocomSlug!}
        title={`Precedenti ${team.name} - ${team2.name}`}
      />

      <Row className={"marginZero"}>
        <Col md={12}>
          <div id="hs-content" className={"hs-border-div paddingZero"}>
            <MatchTeamComparisonStats matches={comparisonMatches} homeTeam={team} awayTeam={team2} />
            <NewTitleBanner title="Partite precedenti" icon={homeTeamStats} />
            <TurnMatches matches={comparisonMatches} loading={false} />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

interface IParams extends ParsedUrlQuery {
  teamCalciocomSlug: string
  teamCalciocomSlug2: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>) {
  try {
    const { teamCalciocomSlug, teamCalciocomSlug2 } = context.params!

    const [teamIds, teamIds2] = await Promise.all([
      TeamAPI.getTeamIds(teamCalciocomSlug),
      TeamAPI.getTeamIds(teamCalciocomSlug2),
    ])

    const [team, team2] = await Promise.all([TeamAPI.getTeam(teamIds.id), TeamAPI.getTeam(teamIds2.id)])

    const comparisonMatches = await MatchAPI.getComparisonMatches(team.id, team2.id, "DESC")

    const title = `Precedenti ${team.name} - ${team2.name}`
    const seo: SEO = {
      title: title,
      description: `Scontri diretti ${team.name} - ${team2.name}, i risultati delle partite di coppa in cui le due squadre si sono incontrate, le curiosità e le statistiche`,
      keywords: [
        `${team.name}`,
        "calcio",
        moment().year().toString(),
        "Rosa",
        "Calendario",
        "Club",
        "Squadra",
        "informazioni",
      ],
      ...(await getTeamCanonicalData(team, null, `/squadre/${teamCalciocomSlug}/precedenti/${teamCalciocomSlug2}`)),
    }

    return {
      props: {
        team,
        team2,
        comparisonMatches,
        navigationProps: await getNavigationPropsForTeam(team.id),
        seo,
        title,
        notFound: false,
      },
      revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
